import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLocale } from '../../contexts/LocaleContext';
import { Link } from '../ui/link';
import { getAdminBreadcrumbItems } from './admin-nav';

export const AdminBreadcrumb: React.FC = () => {
  const location = useLocation();
  const { t } = useLocale();
  const items = getAdminBreadcrumbItems(location.pathname);

  if (items.length === 0) {
    return null;
  }

  return (
    <nav className="flex min-w-0 items-center gap-2 overflow-hidden">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const label = t(item.labelKey);

        return (
          <React.Fragment key={`${item.labelKey}-${index}`}>
            {index > 0 && (
              <span className="shrink-0 text-sm text-muted-foreground">/</span>
            )}
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="truncate text-sm font-normal text-muted-foreground hover:text-foreground hover:underline"
              >
                {label}
              </Link>
            ) : (
              <span
                className={
                  isLast
                    ? 'truncate text-lg font-extrabold text-foreground'
                    : 'truncate text-sm font-normal text-muted-foreground'
                }
              >
                {label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
